import { IFormErrors } from '@interfaces/IFormsErrors';

export interface IUsersChangesState {
  isLoading: boolean;
  success: boolean;
  errors: IFormErrors | null;
}

export const initialUsersChangesState: IUsersChangesState = {
  isLoading: false,
  success: false,
  errors: null,
};
